import { motion } from 'framer-motion';
import styled from 'styled-components';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

export const Wrapper = styled(motion.div)`
    position: absolute;
    width: 90vw;
    height: auto;
    z-index: ${layout.zIndex.modals};
    color: ${colors.white};
    transform: translate(-49.5%, -27.5%);
    overflow: hidden;
    border: 2px solid white;
    border-radius: 20px;
    max-width: 300px;     
    min-height: 210rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    > svg {
        animation: linesAnim 0.8s ease-in-out forwards;
    }

    @keyframes linesAnim {
        from {
            opacity: 0;
            stroke-dasharray: 670;
        }
        to {
            opacity: 1;
            stroke-dasharray: 0;
        }
    }
     
    ${mediaDesktop(`
        max-width: 780px;          
        transform: translate(-75%, -52%);  
    `)}
`;

export const Content = styled.div`
    bottom: 0;
    padding: 20rem;
    background-color: rgba(0,0,0,0.8);
    width: 300px;
    height: 45%;
    border-top: 2px solid white;
    margin-top: 210rem;
    display: flex;
    justify-content: center;
    align-items: center;


    ${mediaDesktop(`
        width: 53.5%; 
        height: 100%; 
        bottom: inherit;
        top: 50%;
        border-right: 2px solid white;
        border-top: none;
        padding: 30rem;
        min-height: 210rem;
        margin-top: 0;
    `)}
`;

export const Title =  styled(motion.h4)`
    font-family: FontRegular;
    font-size: 15rem;
    text-transform: uppercase;
    
    ${mediaDesktop(`
        font-size: 30rem;
    `)};
`;
export const SubTitle = styled(motion.h5)`
    font-family: FontLight;
    font-size: 13rem;
    letter-spacing: 1.6rem;
    text-transform: uppercase;
    ${mediaDesktop(`
        font-size: 26rem;
    `)};
`;
export const Description = styled(motion.p)`
    font-family: FontLight;
    font-size: 12rem;
    ${mediaDesktop(`
        font-size: 20rem;        
    `)};
`;
